import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileState } from '../reducers/profile.reducer';
import { PROFILE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ProfileState>(PROFILE_FEATURE_KEY);

export const selectProfile = createSelector(selectState, (state: ProfileState) => state.profile);
